import { Middleware } from '@reduxjs/toolkit';
import config from '../config';
import { HubConnectionBuilder, HubConnection, HttpTransportType, HubConnectionState } from '@microsoft/signalr';
import { connect,
         connecterror, 
         disconnect,
         setcmslink,
         setrejoincmslink,
         update_UserData,
         update_confirm_UserData,
         update_Meeting_UserStatus,
         update_Docs_Status,
         refresh_Docs,
         update_DocsSign_Status,
         update_DocsSignStapel_Status,
         setsignprozess,
         //setsignprozessstapel,
         update_Prepare_Docs,
         update_SetDoc_Readout,
         update_SetDoc_isSignedByAll,
         setshowsplitdoc,
         store_screenshots,
         remove_screenshot,
         set_updatemeeting,
         set_meetinglogs,
         get_init_screenshotdata, 
         set_idaustriadataloading,
         set_idaustriadata,
         update_confirm_idaustriadata,
         update_participants,
         set_klientidAustriaaccept,
         set_idaustriachachedata,
         update_docstoconvert,
         update_meetinguser_aftersetident,
         close_vk_extern,
         set_usertosignsent,
         guestconnect,
         guest_recive_meetingdata,
         guest_recive_hashconfirmdata,
         guest_recive_joinlinkdata,
         meeting_closed_error,
         guest_recive_notarnotification,
         guest_update_UserData,
         guest_update_Meeting_UserStatus,
         update_SetDoc_Sigblock,
         update_InviteGuestforVK,
         remove_InviteGuestforVK,
         display_active_tab_message,
         guest_set_notactivetab,
         guest_display_reinvite,
         guest_update_InviteGuestforVK,
         guest_remove_InviteGuestforVK,
         update_DeleteDoc_Sigblock,
         set_testdata,
         set_userleave_cms,
         get_user_stapeltodocs_frombackend,
         update_user_stapeltodocs_frombackend,
         updatedataonchangeinDRN,
         guest_updateparticipantsData,
         refresh_Docs_onUpdate,
         kickuser,
         update_sharedsign_docstatus,
         setsetupnotar,
         setsignprozessshared,
         cleare_setsignprozessshared_fromdrn,
         setsignprozesssharedstapel,
         update_set_sigpreparestatus,
         set_modal_stapel_setup_open,
         getadduseriframelink,
         cleare_setsignprozessshared_fromdrn_single} from '../slice/mainslice'


         const processedActions = new Set();

// @ts-ignore 
const signalRMiddleware: Middleware = (store) => {
  let connection: HubConnection | null = null;
  let connectionextern: HubConnection | null = null;
  
  let uri = window.location.href;
  let urlElements = window.location.href.split('/')
  let url = (urlElements[2])
  let apiUrl:any
  let hubendpoint:any
  
  const urlparams = new URLSearchParams(window.location.search);
  const hashParam = urlparams.get('hash');
  const tokenParam = urlparams.get('token');
  const hasTestPath = uri.includes('/test');



  //console.log("hashParam->",hashParam)
  //console.log("tokenParam->",tokenParam)

   // Docker Enviromet Variablen
  if (hashParam !== null && tokenParam === null) {
    if (config.hubUrl !== undefined) {
      apiUrl = config.hubUrlextern
    } else {
      hubendpoint = "extern"
    }
   
  } else if (hashParam === null && tokenParam !== null) { 
    if (config.hubUrl !== undefined) {
      apiUrl = config.hubUrl
    } else {
      hubendpoint = "auth"
    }
  } else if (hasTestPath &&hashParam === null && tokenParam === null) { 
    if (config.hubUrl !== undefined) {
      apiUrl = config.hubUrlextern
    } else {
      hubendpoint = "extern"
    }
  }

  

  // Lokale Testvarianten
  if (url === "savdapp.eu.ngrok.io") {
    apiUrl = "https://notarcms-hub.dev.lilenium.com/hubs/" + hubendpoint
  }
  if (url === "localhost:3000") {
    apiUrl = "https://notarcms-hub.dev.lilenium.com/hubs/" + hubendpoint
  }
  if (url === "savdapp2.eu.ngrok.io") {
    apiUrl = "https://localhost:7096/hubs/" + hubendpoint
  }



  const forceReconnect = () => {
    if (connection) {
      connection.start()
        .then(() => {
          console.log('SignalR reconnection initiated.');
        })
        .catch((error) => {
          console.error('Error reconnecting to SignalR:', error);
        });
    }
  };


  const checkSignalRHealth = async () => {
    
    if (connection && connection.state !== HubConnectionState.Connected) {
      // SignalR connection is not connected, attempt to reconnect or handle as needed
      console.log('SignalR connection is not connected. Reconnecting...');

      // Implement your reconnection logic here
      try {
        if (connection) {
          await connection.start();
        }
        console.log('SignalR reconnection successful.');
      } catch (error) {
        console.error('Error reconnecting to SignalR:', error);
      }
    } else if (connection !== null ) {
      // SignalR connection is connected and healthy
      console.log('SignalR connection is connected and healthy.');
      //console.log(connection
      
    }
  };


    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const healthCheckInterval = setInterval(() => {
      checkSignalRHealth();
    }, 25000);

    
  



  return (next) => async (action: {
    payload(arg0: string, payload: any): unknown; type: any; eventName: string; successActionType: any; token: string | Promise<string> 
}, token: string | Promise<string>) => {

  //console.log(processedActions)

  if (processedActions.has(action.type)) {
    console.log('Action already processed:', action.type);
    return;
  }

  //console.log('Processing action:', action);

    switch (action.type) {
      case 'SIGNALR_CONNECT':
        console.log('SignalR Connection initiated.');
        //console.log(apiUrl)
        connection = new HubConnectionBuilder()
        .withUrl(apiUrl, {
          accessTokenFactory: () => action.token,
          skipNegotiation: true,
          transport: HttpTransportType.WebSockets } as signalR.IHttpConnectionOptions )
          .withAutomaticReconnect()
          .configureLogging(3)
          .build();
 
         // Register reconnection event
            connection.onreconnecting((error) => {
            console.log('Try to reconnecting SignalR ...', error);
            if (error?.message?.includes('maximum message size')) {
              console.error('SignalR: MaximumReceiveMessageSize überschritten!', error.message);
              store.dispatch(connecterror(error));
            }
            forceReconnect();
               });

        connection.onclose((error) => {
        if (error) {
          console.error('SignalR connection closed with error:', error.message);
          // Hier kannst du den Error-Text prüfen:
          if (error.message?.includes('maximum message size')) {
            console.error('Message size exceeded! Increase MaximumReceiveMessageSize on the server.');
            // Optional: Redux-Action dispatchen
            store.dispatch(connecterror(error));
          }
        }
      });



        
        connection.start()
          .then(() => {
            store.dispatch(connect());
            console.log('SignalR connection established. Middleware');
            
          })
          .catch((error) => {
            store.dispatch(connecterror(error));
            console.error('Error connecting to SignalR:', error);
          })
          .finally(() => {});
        break;


      // SiganrlR Guest Connection
      case 'SIGNALR_CONNECT_GUEST':
        
        connectionextern = new HubConnectionBuilder()
            .withUrl(apiUrl, {
              //accessTokenFactory: () => keycloak.token,
              skipNegotiation: true,
              transport: HttpTransportType.WebSockets } as signalR.IHttpConnectionOptions )
             //.withUrl('http://10.1.4.61:5001/hubs/chat', {accessTokenFactory: () => keycloak.token  } as signalR.IHttpConnectionOptions )
           .withAutomaticReconnect()
           .configureLogging(3)
           .build();
           //console.log(connectionextern) 

           connectionextern.start()
          .then(() => {
            store.dispatch(guestconnect());
            console.log('SignalR Guest connection established. Middleware');
            
          })
          .catch((error) => {
            store.dispatch(guestconnect());
            console.error('Error Guest connecting to SignalR:', error);
          })
          .finally(() => {});
      break;

        
      // Messages with Account  
      // Send Message
      /**
       * Send payload to change current scene in meeting via SignalR.
       * 
       * Sends the scene change payload to the SignalR hub to notify 
       * server and other clients of the new current scene.
       */
      case 'SIGNALR_CHANGECURRENTSZENE':
          if (connection) {
           // console.log("SIGNALR_CHANGECURRENTSZENE")
            try {
            //   console.log("Sending Data SIGNALR_CHANGECURRENTSZENE")
            await connection.invoke('ChangeCurrentSzene', action.payload);
            } catch (error) {
               console.error('Error sending message:', error);
            }
          }
        break;

      /**
       * Sends a request via SignalR to start a meeting. 
       * 
       * This sends a payload with the meeting ID to the SignalR hub.
       * The hub then requests a meeting link from the server.
       * If successful, the server will return the meeting link 
       * to the client via the SignalR connection.
       */
        case 'SIGNALR_REQUESTSTARTMEETING':
          if (connection) {
            //console.log("SIGNALR_REQUESTSTARTMEETING")
            try {
             //  console.log("Sending Data SIGNALR_REQUESTSTARTMEETING")
            await connection.invoke('RequestMeetingLink', action.payload);
            } catch (error) {
               console.error('Error sending message:', error);
            }
          }
        break;





        case 'SIGNALR_REQUESTREJOINMEETING':
          if (connection) {
         //   console.log("SIGNALR_REQUESTREJOINMEETING")
            try {
           //    console.log("Sending Data SIGNALR_REQUESTREJOINMEETING")
            await connection.invoke('GetCapsuleLink', action.payload);
            } catch (error) {
               console.error('Error sending message:', error);
            }
          }
        break;

        case 'SIGNALR_REQUESTIDENTSCENE':
          if (connection) {
           // console.log("SIGNALR_REQUESTIDENTSCENE")
            try {
           //    console.log("Sending Data SIGNALR_REQUESTIDENTSCENE")
            await connection.invoke('ToggleSceneWithAction', action.payload);
            } catch (error) {
               console.error('Error sending message:', error);
            }
          }
        break;

        case 'SIGNALR_SENDCONFIRMUSER':
          if (connection) {
         //   console.log("SIGNALR_SENDCONFIRMUSER")
            try {
         //     console.log("Sending Data SIGNALR_SENDCONFIRMUSER")
            await connection.invoke('ConfirmUserIdentity', action.payload);
            } catch (error) {
               console.error('Error sending message:', error);
            }
          }
        break;
 
        case 'SIGNALR_SENDOPENDOC': 
          if (connection) {
            //console.log("SIGNALR_SENDOPENDOC")
            try {
               console.log("Sending Data SIGNALR_SENDOPENDOC")
            await connection.invoke("HandleDocument", action.payload);
            } catch (error) {
               console.error('Error sending message:', error);
            }
          }
        break;
        

        case 'SIGNALR_SENDOPENDOCFORSIGN':
          if (connection) {
            //console.log("SIGNALR_SENDOPENDOC")
            try {
               console.log("Sending Data SIGNALR_SENDOPENDOCFORSIGN")
            await connection.invoke("OpenDocumentForSign", action.payload);
            } catch (error) {
               console.error('Error sending message:', error);
            }
          }
        break;

        // Neue Funktion für DEMO senden des OPen Befehls
        case 'SIGNALR_SENDOPENDOCFORSIGNSHARED':
          if (connection) {
            //console.log("SIGNALR_SENDOPENDOC")
            try {
               console.log("Sending Data SIGNALR_SENDOPENDOCFORSIGNSHARED")
            await connection.invoke("OpenCloseDocumentSharedLink", action.payload);
            } catch (error) {
               console.error('Error sending message:', error);
            }
          }
        break;

        case 'SIGNALR_SENDOPENDOCFORSIGNSTAPELSHARED':
          if (connection) {
            console.log("SIGNALR_SENDOPENDOC")
            try {
               console.log("Sending Data SIGNALR_SENDOPENDOCFORSIGNSTAPELSHARED")
            await connection.invoke("OpenCloseStapelSharedLink", action.payload);
            } catch (error) {
               console.error('Error sending message:', error);
            }
          }
        break;




        case 'SIGNALR_SIGNDOCOK':
          if (connection) {
            //console.log("SIGNALR_SENDOPENDOC")
            try {
               console.log("Sending Data SIGNALR_SIGNDOCOK")
            await connection.invoke("ConfirmUserSignature", action.payload);
            } catch (error) {
               console.error('Error sending message:', error);
            }
          }
        break;

        case 'SIGNALR_SENDSETUPMEETING':
          if (connection) {
            try {
               console.log("Sending Data SIGNALR_SENDSETUPMEETING")
            await connection.invoke("PrepareDocuments", action.payload);
            } catch (error) {
               console.error('Error sending message:', error);
            }
          }
        break;

        case 'SIGNALR_SETDOCUMENTISSIGNEDBYAll':
        if (connection) {
          try {
             console.log("Sending Data SIGNALR_SETDOCUMENTISSIGNEDBYAll")
          await connection.invoke("SetDocumentIsSignedByAll", action.payload);
          } catch (error) {
             console.error('Error sending message:', error);
          }
        }
      break;


      case 'SIGNALR_SETDOCUMENTISREADOUT':
        if (connection) {
          try {
             console.log("Sending Data SIGNALR_SETDOCUMENTISREADOUT")
          await connection.invoke("SetDocumentIsReadOut", action.payload);
          } catch (error) {
             console.error('Error sending message:', error);
          }
        }
      break;

      
      case 'SIGNALR_GETINITSCREENSHOT':
        if (connection) {
          try {
             console.log("Sending Data SIGNALR_GETINITSCREENSHOT")
          await connection.invoke("GetSnapshotsByDrnId", action.payload);
          } catch (error) {
             console.error('Error sending message:', error);
          }
        }
      break;


      
            /**
       * Sends a SIGNALR_SENDCLOSEMEETING_ZIPARCHIV message to the SignalR connection on Logout from Applikation 
       * 
       * 
       * The action.payload will contain data needed for send Meeting Info as Package to DRN.
       * 
       * Logs any errors sending the message.
      */
      case 'SIGNALR_SENDCLOSEMEETING_ZIPARCHIV':
        if (connection) {
          try {
             console.log("Sending SIGNALR_SENDCLOSEMEETING_ZIPARCHIV")
          await connection.invoke("UploadZipOnNdr", action.payload);
          } catch (error) {
             console.error('Error sending message:', error);
          }
        }
      break;


      



      /**
       * Sends a SIGNALR_MAKESCREENSHOT message to the SignalR connection 
       * to invoke the TakeSnapshot method on the server.
       * 
       * The action.payload will contain data needed for the screenshot.
       * 
       * Logs any errors sending the message.
      */
      case 'SIGNALR_MAKESCREENSHOT':
        if (connection) {
          try {
             console.log("Sending Data SIGNALR_MAKESCREENSHOT")
          await connection.invoke("TakeSnapshot", action.payload);
          } catch (error) {
             console.error('Error sending message:', error);
          }
        }
      break;

      /**
       * Sends a SIGNALR_DELETE_SCREENSHOT message to the SignalR connection
       * to invoke the DeleteSnapshot method on the server.
       * 
       * The action.payload will contain the screenshotId to delete.
       * 
       * Logs any errors sending the message.
      */
      case 'SIGNALR_DELETE_SCREENSHOT':
        if (connection) {
          try {
             console.log("SIGNALR_DELETE_SCREENSHOT")
          await connection.invoke("DeleteSnapshot", action.payload);
          } catch (error) {
             console.error('Error sending message:', error);
          }
        }
      break;

      case 'SIGNALR_UDATE_MEETINGDATE':
        if (connection) {
          try {
             console.log("SIGNALR_UDATE_MEETINGDATE'")
          await connection.invoke("UpdateMeetingDate", action.payload);
          } catch (error) {
             console.error('Error sending message:', error);
          }
        }
      break;


      case 'SIGNALR_SENDCLOSEMEETING':
        if (connection) {
          try {
             console.log("SIGNALR_SENDCLOSEMEETING")
          await connection.invoke("CloseVideoPopup");
          } catch (error) {
             console.error('Error sending message:', error);
          }
        }
      break;


      case 'SIGNALR_GET_MEETINGLOG':
        if (connection) {
          try {
             console.log("SIGNALR_GET_MEETINGLOG")
          await connection.invoke("GetMeetingLogs", action.payload);
          } catch (error) {
             console.error('Error sending message:', error);
          }
        }
      break;

      case 'SIGNALR_GET_REFRESHDOCS':
        if (connection) {
          try {
             console.log("SIGNALR_GET_REFRESHDOCS")
          await connection.invoke("RefreshDocumentsFolder", action.payload);
          
          } catch (error) {
             console.error('Error sending message:', error);
          }
        }
      break;

      case 'SIGNALR_GETIDAUSTRIADATA':
        if (connection) {
          try {
             console.log("Sending Data SIGNALR_GETIDAUSTRIADATA")
          await connection.invoke("RequestIdAustriaIdentification", action.payload);
          } catch (error) {
             console.error('Error sending message:', error);
          }
        }
      break;


      case 'SIGNALR_IDAUSTRIA_OK':
        if (connection) {
          try {
             console.log("Sending Data SIGNALR_IDAUSTRIA_OK")
          await connection.invoke("SetIdAustriaConformation", action.payload);
          } catch (error) {
             console.error('Error sending message:', error);
          }
        }
      break;

      case 'SIGNALR_SEND_ALIAS':
        if (connection) {
          try {
             console.log("Sending Data SIGNALR_SEND_ALIAS")
          await connection.invoke("ChangeNotarFirstAndLastName", action.payload);
          } catch (error) {
             console.error('Error sending message:', error);
          }
        }
      break;

      case 'SIGNALR_CLOSEDRNPOPUP':
        if (connection) {
          console.log("SIGNALR_CLOSEDRNPOPUP")
          try {
             console.log("Sending Data SIGNALR_CLOSEDRNPOPUP")
          await connection.invoke('CloseIdAustriaPopup', action.payload);
          } catch (error) {
             console.error('Error sending message:', error);
          }
        }
      break;


      case 'SIGNALR_REQUEST_CONVERTDOKS':
        if (connection) {
          console.log("SIGNALR_REQUEST_CONVERTDOKS")
          try {
             console.log("Sending Data SIGNALR_REQUEST_CONVERTDOKS")
          await connection.invoke('TryToConvertPdfsToA1bFormat', action.payload);
          } catch (error) {
             console.error('Error sending message:', error);
          }
        }
      break;

      // Send Participants To Be Identified
      case 'SIGNALR_SEND_USERTOIDENT':
        if (connection) {
          console.log("SIGNALR_SEND_USERTOIDENT")
          try {
             console.log("Sending Data SIGNALR_SEND_USERTOIDENT")
          await connection.invoke('SetParticipantsToBeIdentified', action.payload);
          } catch (error) {
             console.error('Error sending message:', error);
          }
        }
      break;


      /**
       * Sends a "SIGNALR_SENDSETDOCISPREPARED" message to the SignalR connection
       * to invoke the SetDocumentIsSigPrepared method on the server.
       * 
       * The action.payload will contain the drnid,resourceId,isSigPrepared to update state of document has been prepared.
       * 
       * Logs any errors sending the message.
      */
      case 'SIGNALR_SENDSETDOCISPREPARED':
        if (connection) {
          console.log("SIGNALR_SENDSETDOCISPREPARED")
          try {
             console.log("Sending Data SIGNALR_SENDSETDOCISPREPARED")
          await connection.invoke('SetDocumentIsSigPrepared', action.payload);
          } catch (error) {
             console.error('Error sending message:', error);
          }
        }
      break;

      /**
       * Sends a "SIGNALR_SENDSETUSERFORSIGBLOCKSETUP" message to the SignalR connection
       * to invoke the SetDocumentIsSigPrepared method on the server.
       * 
       * The action.payload will contain the drnid,resourceId,user to configure DocSetup on DRN Side.
       * 
       * Logs any errors sending the message.
      */
      case 'SIGNALR_SENDSETUSERFORSIGBLOCKSETUP':
        if (connection) {
          console.log("IGNALR_SENDSETUSERFORSIGBLOCKSETUP")
          try {
             console.log("Sending Data IGNALR_SENDSETUSERFORSIGBLOCKSETUP")
          await connection.invoke('PrepareSignatureLayoutByDocument', action.payload);
          } catch (error) {
             console.error('Error sending message:', error);
          }
        }
      break;

      /**
       * Sends a "SIGNALR_SENDSETUSERFORSIGBLOCKSETUP" message to the SignalR connection
       * to invoke the SetDocumentIsSigPrepared method on the server.
       * 
       * The action.payload will contain the drnid,resourceId,user to configure DocSetup on DRN Side.
       * 
       * Logs any errors sending the message.
      */
      case 'SIGNALR_SENDRESETPREPARESIGNATURELAYOUT':
        if (connection) {
          console.log("SIGNALR_SENDRESETPREPARESIGNATURELAYOUT")
          try {
             console.log("Sending Data SIGNALR_SENDRESETPREPARESIGNATURELAYOUT")
          await connection.invoke('DeleteSignatureLayoutByDocument', action.payload);
          } catch (error) {
             console.error('Error sending message:', error);
          }
        }
      break;



      /**
       * Sends a "SIGNALR_CREATESTAPELFORSIGN" message to the SignalR connection
       * to invoke the CreateStapel method on the server.
       * 
       * The action.payload will contain the participantId:,resourceId to configure Stapelsignatur on DRN Side.
       * 
       * Logs any errors sending the message.
      */
      case 'SIGNALR_CREATESTAPELFORSIGN':
        if (connection) {
          console.log("SIGNALR_CREATESTAPELFORSIGN")
          try {
             console.log("Sending Data SIGNALR_CREATESTAPELFORSIGN")
          await connection.invoke('CreateStapel', action.payload);
          } catch (error) {
             console.error('Error sending message:', error);
          }
        }
      break;


            /**
       * Sends a "SIGNALR_UPDATESTAPELFORSIGN" message to the SignalR connection
       * to invoke the CreateStapel method on the server.
       * 
       * The action.payload will contain the participantId:,resourceId to configure Stapelsignatur on DRN Side.
       * 
       * Logs any errors sending the message.
      */
            case 'SIGNALR_UPDATESTAPELFORSIGN':
              if (connection) {
                //console.log("SIGNALR_UPDATESTAPELFORSIGN")
                //console.log("action.payload", action.payload) 
                try {
                  // console.log("Sending Data SIGNALR_UPDATESTAPELFORSIGN")
                await connection.invoke('UpdateStapel', action.payload);
                } catch (error) {
                   console.error('Error sending message:', error);
                }
              }
            break;



       /**
       * Sends a "SIGNALR_INVITEGUESTFROMVK" message to the SignalR connection
       * to invoke the InviteGuestFromVk method on the server.
       * 
       * The action.payload will contain the drnid,email to add an Guest User to meeting.
       * 
       * Logs any errors sending the message.
      */
      case 'SIGNALR_INVITEGUESTFROMVK':
        if (connection) {
          //console.log("SIGNALR_INVITEGUESTFROMVK")
          try {
             console.log("Sending Data SIGNALR_INVITEGUESTFROMVK")
          await connection.invoke('InviteGuestFromVk', action.payload);
          } catch (error) {
             console.error('Error sending message:', error);
          }
        }
      break;

       /**
       * Sends a "SIGNALR_REMOVEGUESTFROMVK" message to the SignalR connection
       * to invoke the BlockGuestFromVk method on the server.
       * 
       * The action.payload will contain the drnid,email to remove an Guest User from an meeting.
       * 
       * Logs any errors sending the message.
      */
case 'SIGNALR_REMOVEGUESTFROMVK':
  if (connection) {
    //console.log("SIGNALR_REMOVEGUESTFROMVK")
    try {
       console.log("Sending Data SIGNALR_REMOVEGUESTFROMVK")
    await connection.invoke('BlockGuestFromVk', action.payload);
    } catch (error) {
       console.error('Error sending message:', error);
    }
  }
break;

/**
       * Sends a "SIGNALR_REINVITEGUESTFROMVK" message to the SignalR connection
       * to invoke the ReInviteGuestFromVk method on the server.
       * 
       * The action.payload will contain the drnid,email to add an Guest User to meeting.
       * 
       * Logs any errors sending the message.
      */
case 'SIGNALR_REINVITEGUESTFROMVK':
  if (connection) {
    //console.log("SIGNALR_REINVITEGUESTFROMVK")
    try {
       console.log("Sending Data SIGNALR_REINVITEGUESTFROMVK")
    await connection.invoke('ReInviteParticipantsFromVk', action.payload);
    } catch (error) {
       console.error('Error sending message:', error);
    }
  }
break;


case 'SIGNALR_REMOVEPATRICIPANTFROMCMS':
  if (connection) {
     // console.log("SIGNALR_REMOVEPATRICIPANTFROMCMS")
    try {
     // console.log("Sending Data SIGNALR_REMOVEPATRICIPANTFROMCMS")
    await connection.invoke('DisconnectByChangeLanguage', action.payload);
    } catch (error) {
      console.error('Error sending message:', error);
    }
  }
break;



case 'SIGNALR_REMOVESTAPEL':
  if (connection) {
   // console.log("SIGNALR_REMOVEGUESTFROMVK")
   // console.log("action.payload", action.payload)
    try {
    await connection.invoke('RemoveStapel', action.payload);
    } catch (error) {
       console.error('Error sending message:', error);
    }
  }
break;


case 'SIGNALR_OPENSTAPELFORSIGN':
  if (connection) {
    //console.log("SIGNALR_REMOVEGUESTFROMVK")
    try {
    await connection.invoke('OpenCloseStapelForSign', action.payload);
    } catch (error) {
       console.error('Error sending message:', error);
    }
  }
break;

case 'SIGNALR_SIGNSTAPELDOCOK':
  if (connection) {
    //console.log("SIGNALR_REMOVEGUESTFROMVK")
    try {
    await connection.invoke('ConfirmUserSignatureStapel', action.payload);
    } catch (error) {
       console.error('Error sending message:', error);
    }
  }
break;

case 'SIGNALR_SETUP_STAPEL_SIG_PREPARED':
  if (connection) {
    //console.log("SIGNALR_SETUP_STAPEL_SIG_PREPARED", action.payload)
    try {
    await connection.invoke('SetSignaturePreparationStatus', action.payload);
    } catch (error) {
       console.error('Error sending message:', error);
    }
  }
break;


 case 'SIGNALR_GETADDUSER_FROMDRN':
          if (connection) {
            //console.log("SIGNALR_REQUESTSTARTMEETING")
            try {
             //  console.log("Sending Data SIGNALR_REQUESTSTARTMEETING")
            await connection.invoke('GetAddParticipantPopupLink');
            } catch (error) {
               console.error('Error sending message:', error);
            }
          }
        break;







      


      


      





     
        
       // Listener To Incoming Message
      /**
       * Listens for the SIGNALR_RECIVEMEETINGLINK event from the SignalR connection. 
       * When received, it will log the event and data, dispatch the setcmslink action 
       * with the received data, and break out of the switch case.
      */
       case 'SIGNALR_RECIVEMEETINGLINK':
        if (connection) {
        //  console.log("Listening to SIGNALR-> " + action.eventName) 
          connection.on(action.eventName, (data) => {
      //    console.log("Recive Data SIGNALR-> " + action.eventName) 
         // console.log(data)
            store.dispatch(setcmslink(data)); 
          });
        }
        break; 

        case 'SIGNALR_RECIVEREJOINMEETINGLINK':
          if (connection) {
          //   console.log("Listening to SIGNALR-> " + action.eventName) 
            connection.on(action.eventName, (data) => {
         //   console.log("Recive Data SIGNALR-> " + action.eventName) 
            //console.log(data)
            const isPayloadChanged = JSON.stringify(data) !== JSON.stringify(store.getState().user.cmslink);
            //console.log(store.getState().user.cmslink)
           // console.log(data)
            //console.log(isPayloadChanged)
              if (isPayloadChanged){
              store.dispatch(setrejoincmslink(data));
              }
            });
          }
        break;






          case 'SIGNALR_GETIDA_CACHE':
            if (connection) {
           //   console.log("SIGNALR_GETIDA_CACHE-> ") 
              connection.on(action.eventName, (data) => {
              //console.log("SIGNALR_GETIDA_CACHE-> ") 
              store.dispatch(set_idaustriachachedata(data));
                
              });
            }
            break;

        case 'SIGNALR_UPDATE_USERDATA':
          if (connection) {
          //   console.log("Listening to SIGNALR_UPDATE_USERDATA for " + action.eventName)
            connection.on(action.eventName, (data) => {
              //console.log("GET Data SIGNALR_UPDATE_USERDATA for " + action.eventName)
              
              store.dispatch(update_UserData(data));
            });
          }
        break; 

        case 'SIGNALR_CONFIRM_USERDATA':
          if (connection) {
           //  console.log("Listening to SIGNALR_CONFIRM_USERDATA")
            connection.on(action.eventName, (data) => {
              //console.log("GET Data SIGNALR_CONFIRM_USERDATA)
              store.dispatch(update_confirm_UserData(data));
            });
          }
        break; 

        case 'SIGNALR_CHANGEMEETING_STATUSUSER':
          if (connection) {
            //   console.log("Listening to SIGNALR_CHANGEMEETING_STATUSUSER")
              connection.on(action.eventName, (data) => {
              store.dispatch(update_Meeting_UserStatus(data));
              });
            }
        break; 

        case 'SIGNALR_ALLLEFT_STATUSUSER':
          if (connection) {
            //   console.log("Listening to SIGNALR_CHANGEMEETING_STATUSUSER")
              connection.on(action.eventName, (data) => {
              store.dispatch(update_Meeting_UserStatus(data));
              });
            }
        break;

        // eslint-disable-next-line no-duplicate-case
        case 'SIGNALR_ALLLEFT_STATUSUSER':
          if (connection) {
            //   console.log("Listening to SIGNALR_CHANGEMEETING_STATUSUSER")
              connection.on(action.eventName, (data) => {
              store.dispatch(update_Meeting_UserStatus(data));
              });
            }
        break;

        case 'SIGNALR_RECIVEDOCUPDATE':
            if (connection) {
            // console.log("Listening to SIGNALR_RECIVEDOCUPDATE")
                connection.on(action.eventName, (data) => {
              //    console.log("GET Data SIGNALR_RECIVEDOCUPDATE")
               //   console.log(data)
                  store.dispatch(update_Docs_Status(data));
                });
              }
        break;


        case 'SIGNALR_RECIVEOPENDOC':
            if (connection) {
            //   console.log("Listening to SIGNALR_RECIVEOPENDOC")
                connection.on(action.eventName, (data) => {
                  //console.log(data)
                  store.dispatch(setsignprozess(data));
                });
              }
        break; 

        case 'SIGNALR_RECIVECONFDOC':
            if (connection) {
           //    console.log("Listening to SIGNALR_RECIVECONFDOC")
                connection.on(action.eventName, (data) => {
                 console.log(data)
                  store.dispatch(update_DocsSign_Status(data));
                });
              }
        break;

        case 'SIGNALR_RECIVESHAREDSIGNDOCSTATUS':
            if (connection) {
              //console.log("Listening to SIGNALR_RECIVESHAREDSIGNDOCSTATUS")
                connection.on(action.eventName, (data) => {
                // console.log(data)
                  store.dispatch(update_sharedsign_docstatus(data));
                });
              }
        break;

        

        
        case 'SIGNALR_RECIVECONFSTAPELDOC':
            if (connection) {
           //    console.log("Listening to SIGNALR_RECIVECONFDOC")
                connection.on(action.eventName, (data) => {
                 //console.log(data)
                  store.dispatch(update_DocsSignStapel_Status(data));
                });
              }
        break;

        case 'SIGNALR_RECIVEOPEDNDOCFORSIGN':
          if (connection) {
           //  console.log("Listening to SIGNALR_RECIVECONFDOC")
              connection.on(action.eventName, (data) => {
                 console.log(data)
                 store.dispatch(setsignprozess(data));
              });
            }
      break;

      // Neue Funktion für DEMO empfangen des OPen Befehls   
      case 'SIGNALR_RECIVE_OC_DOCUMENT_SL':
          if (connection) {
            //console.log("Listening to SIGNALR_RECIVE_OC_DOCUMENT_SL")
              connection.on(action.eventName, (data) => {
                 //console.log("DOCUMENT_SHARED_LINK",data)
                 store.dispatch(setsignprozessshared(data));
              });
            }
      break; 
       
      case 'SIGNALR_RECIVE_OC_DOCUMENT_SL_STAPEL':
          if (connection) {
            //console.log("Listening to SIGNALR_RECIVE_OC_DOCUMENT_SL_STAPEL")
              connection.on(action.eventName, (data) => {
                // console.log("SIGNALR_RECIVE_OC_DOCUMENT_SL",data)
                 store.dispatch(setsignprozesssharedstapel(data));
              });
            }
      break;
      
      



      case 'SIGNALR_RECIVEONHANDLEDOCUMENT':
        if (connection) {
         //  console.log("Listening to SIGNALR_RECIVEONHANDLEDOCUMENT")
            connection.on(action.eventName, (data) => {
               console.log(data)
               store.dispatch(setshowsplitdoc(data));
            });
          }
      break;
      

      case 'SIGNALR_RECIVE_ONPREPAREDOCUMENTS':
        if (connection) {
         //  console.log("SIGNALR_RECIVE_ONPREPAREDOCUMENTS")

            connection.on(action.eventName, (data) => {
               //console.log(data)
               store.dispatch(update_Prepare_Docs(data));
            });
          }
      break;
      

      case 'SIGNALR_RECIVE_ONUPDATEMEETINGANDPARTICIPANTSDATA':
        if (connection) {
         //  console.log("SIGNALR_RECIVE_ONPREPAREDOCUMENTS")

            connection.on(action.eventName, (data) => {
               console.log(data)
               store.dispatch(updatedataonchangeinDRN(data));
            });
          }
      break;

      /**
       * Listens for the SIGNALR_RECIVE_ONSETDOCUMENTSISREADOUT event from the SignalR connection.
       * When received, dispatches the update_SetDoc_Readout action with the received data
       * as the payload to update the document readout status in the Redux store.
      */
      case 'SIGNALR_RECIVE_ONSETDOCUMENTSISREADOUT':
        if (connection) {
        //   console.log("SIGNALR_RECIVE_ONSETDOCUMENTSISREADOUT")

            connection.on(action.eventName, (data) => {
               //console.log(data)
               store.dispatch(update_SetDoc_Readout(data));
            });
          }
      break;


      case 'SIGNALR_RECIVE_ONSETDOCUMENTISSIGNEDBYAll':
        if (connection) {
        //   console.log("SIGNALR_RECIVE_ONSETDOCUMENTISSIGNEDBYAll")

            connection.on(action.eventName, (data) => {
               //console.log(data)
               store.dispatch(update_SetDoc_isSignedByAll(data));
            });
          }
      break;



      case 'SIGNALR_ONCREATESTAPEL':
        if (connection) {
        //   console.log("SIGNALR_RECIVE_ONSETDOCUMENTISSIGNEDBYAll")

            connection.on(action.eventName, (data) => {
               //console.log("SIGNALR_ONCREATESTAPEL",data)
               store.dispatch(get_user_stapeltodocs_frombackend(data));
            });
          }
      break;

      case 'SIGNALR_ONUPDATESTAPEL':
        if (connection) {
          // console.log("SIGNALR_RECIVE_SIGNALR_ONUPDATESTAPEL")
            connection.on(action.eventName, (data) => {
               //console.log("SIGNALR_ONUPDATESTAPEL",data)
               store.dispatch(update_user_stapeltodocs_frombackend(data));
            });
          }
      break;

      case 'SIGNALR_ONREMOVESTAPEL':
        if (connection) {
        //   console.log("SIGNALR_RECIVE_SIGNALR_ONREMOVESTAPEL")
            connection.on(action.eventName, (data) => {
               //console.log("SIGNALR_ONUPDATESTAPEL",data)
               store.dispatch(get_user_stapeltodocs_frombackend(data));
            });
          }
      break;

      



      

      




      /**
       * Listens for the SIGNALR_RECIVE_TAKENSCREENSHOT event from the SignalR connection. 
       * When received, dispatches the store_screenshots action with the received data 
       * as the payload to store the screenshot data in the Redux store.
      */
      case 'SIGNALR_RECIVE_TAKENSCREENSHOT':
        if (connection) {
        //   console.log("SIGNALR_RECIVE_TAKENSCREENSHOT")

            connection.on(action.eventName, (data) => {
               //console.log(data)
               store.dispatch(store_screenshots(data));
            });
          }
      break;


      /**
       * Listens for the SIGNALR_REMOVE_SCREENSHOT event from the SignalR connection.
       * When received, logs the received data and dispatches the remove_screenshot 
       * action to remove the corresponding screenshot data from the Redux store.
      */
      case 'SIGNALR_REMOVE_SCREENSHOT':
        if (connection) {
        //   console.log("SIGNALR_REMOVE_SCREENSHOT")
            connection.on(action.eventName, (data) => {
               //console.log(data)
               store.dispatch(remove_screenshot(data));
            });
          }
      break;

      /**
       * Listens for the SIGNALR_INIT_SCREENSHOTDATA event from the SignalR 
       * connection. When received, logs the event name, dispatches the 
       * get_init_screenshotdata action to store the initial screenshot data 
       * in Redux.
       */

      case 'SIGNALR_INIT_SCREENSHOTDATA':
        if (connection) {
         //  console.log("SIGNALR_INIT_SCREENSHOTDATA")
            connection.on(action.eventName, (data) => {
               //console.log(data)
               store.dispatch(get_init_screenshotdata(data));
            });
          }
      break;


      case 'SIGNALR_UPDATEMEETINGDATA':
        if (connection) {
        //   console.log("SIGNALR_SIGNALR_UPDATEMEETINGDATA")
            connection.on(action.eventName, (data) => {
               //console.log(data)
               store.dispatch(set_updatemeeting(data));
            });
          }
      break;

      
      case 'SIGNALR_RECIVE_MEETINGLOGS':
        if (connection) {
        //   console.log("SIGNALR_SIGNALR_UPDATEMEETINGDATA")
            connection.on(action.eventName, (data) => {
               store.dispatch(set_meetinglogs(data));
            });
          }
      break;


      case 'SIGNALR_RECIVE_REFRESH_DOCS':
        if (connection) {
        //   console.log("SIGNALR_RECIVE_REFRESH_DOCS")
            connection.on(action.eventName, (data) => {
              store.dispatch(refresh_Docs(data));
              
              // store.dispatch(set_meetinglogs(data));
            });
          }
      break;

      case 'SIGNALR_RECIVE_ONUPDATE_DOCS_FOLDERFROMDRN':
        if (connection) {
    //  console.log("SIGNALR_RECIVE_ONUPDATE_DOCS_FOLDERFROMDRN")
            connection.on(action.eventName, (data) => {
              //Update Dta
              //console.log("SIGNALR_RECIVE_ONUPDATE_DOCS_FOLDERFROMDRN",data)
              store.dispatch(refresh_Docs_onUpdate(data)); 
              // store.dispatch(set_meetinglogs(data));
            });
          }
      break;

      case 'SIGNALR_RECIVE_ONUPDATE_SIGS_STATUSUPDATE':
        if (connection) {
    //  console.log("SIGNALR_RECIVE_ONUPDATE_SIGS_STATUSUPDATE")
            connection.on(action.eventName, (data) => {
              //console.log(data)
              //Update Dta
              //store.dispatch(refresh_Docs_onUpdate(data)); 
              store.dispatch(cleare_setsignprozessshared_fromdrn_single(data));
            });
          }
      break;

      case 'SIGNALR_ONUPDATESTAPELSIGNATURE':
        if (connection) {
    //  console.log("SIGNALR_ONUPDATESTAPELSIGNATURE")
            connection.on(action.eventName, (data) => {
              //console.log("SIGNALR_ONUPDATESTAPELSIGNATURE",data)
              //Update Dta
              //store.dispatch(refresh_Docs_onUpdate(data)); 
              store.dispatch(cleare_setsignprozessshared_fromdrn(data));
            });
          }
      break;




      


      case 'SIGNALR_RECIVE_IDAUSTRIA_DATA':
        if (connection) {
           console.log("SIGNALR_RECIVE_IDAUSTRIA_DATA") 
            connection.on(action.eventName, (data) => {
             // console.log(data)
              //
              //store.dispatch(set_klientidAustriaaccept(data));
              store.dispatch(set_idaustriadataloading(data));
            });
          }
      break;

      case 'SIGNALR_RECIVE_IDAUSTRIA_DATAFULL':
        if (connection) {
     //   console.log("SIGNALR_RECIVE_IDAUSTRIA_DATAFULL")
            connection.on(action.eventName, (data) => {
             // console.log(data)
              store.dispatch(set_idaustriadata(data));
            });
          }
      break;

      case 'SIGNALR_RECIVE_IDAUSTRIA_IDAUSTRIAOK':
        if (connection) {
          //console.log("Listening to SIGNALR_UPDATE_USERDATA for " + action.eventName)
          connection.on(action.eventName, (data) => {
           console.log("GET Data SIGNALR_RECIVE_IDAUSTRIA_IDAUSTRIAOK for " + action.eventName)
           console.log(data)
            store.dispatch(update_confirm_idaustriadata(data));
          });
        }
      break; 


      case 'SIGNALR_RECIVE_ALIAS_DATA':
        if (connection) {
          //console.log("Listening to SIGNALR_UPDATE_USERDATA for " + action.eventName)
          connection.on(action.eventName, (data) => {
           // console.log("GET Data SIGNALR_RECIVE_IDAUSTRIA_IDAUSTRIAOK for " + action.eventName)
            store.dispatch(update_participants(data))
            //store.dispatch(update_confirm_idaustriadata(data));
          });
        }
      break; 

      case 'SIGNALR_RECIVE_CONFIRM_DRN_IDA':
        if (connection) {
          //console.log("Listening to SIGNALR_UPDATE_USERDATA for " + action.eventName)
          connection.on(action.eventName, (data) => {
           // console.log("GET Data SIGNALR_RECIVE_CONFIRM_DRN_IDA for " + action.eventName)
            store.dispatch(set_klientidAustriaaccept(data))

          });
        }
      break; 

      case 'SIGNALR_RECIVE_CONFIRM_PDFCONVERT':
        if (connection) {
          //console.log("Listening to SIGNALR_UPDATE_USERDATA for " + action.eventName)
          connection.on(action.eventName, (data) => {
            //console.log("GET Data SIGNALR_RECIVE_CONFIRM_PDFCONVERT for " + action.eventName)
            store.dispatch(update_docstoconvert(data))
          });
        }
      break; 


      case 'SIGNALR_RECIVE_PARTICIPANTSTOBEIDENTIFIED':
        if (connection) {
          //console.log("Listening to SIGNALR_RECIVE_PARTICIPANTSTOBEIDENTIFIED")
          connection.on(action.eventName, (data) => {
            //console.log("Get Data SIGNALR_RECIVE_PARTICIPANTSTOBEIDENTIFIED")
            //console.log(data)
           store.dispatch(update_meetinguser_aftersetident(data))
          });
        }
      break; 

      
      case 'SIGNALR_CLOSEVK_IN_DRN':
        if (connection) {
          //console.log("Listening to SIGNALR_UPDATE_USERDATA for " + action.eventName)
          connection.on(action.eventName, (data) => {
            console.log("Get Data SIGNALR_CLOSEVK_IN_DRN")
           store.dispatch(close_vk_extern(data))
          });
        }
      break; 
 
      case 'SIGNALR_RECIVESETUSERFORSIGBLOCKSETUP':
        if (connection) {
          connection.on(action.eventName, (data) => {
            console.log("Get Data SIGNALR_RECIVESETUSERFORSIGBLOCKSETUP")
            store.dispatch(set_usertosignsent(data))
          });
        }
      break;

      
      case 'SIGNALR_RECIVESETDOCUMENTISSIGPREPARED':
        if (connection) {
          connection.on(action.eventName, (data) => {
            console.log("Get Data SIGNALR_RECIVESETDOCUMENTISSIGPREPARED")
           // console.log(data)
            store.dispatch(update_SetDoc_Sigblock(data))
          });
        }
      break;
      
      // Set the Status of the Siganture Block
      case 'SIGNALR_ONDELETESIGNATURELAYOUT':
        if (connection) {
          connection.on(action.eventName, (data) => {
            console.log("Get Data SIGNALR_ONDELETESIGNATURELAYOUT")
            //console.log(data)
            store.dispatch(update_DeleteDoc_Sigblock(data))
          });
        }
      break;
      


      case 'SIGNALR_RECIVEONINVITEGURSTFROMVK':
        if (connection) {
          connection.on(action.eventName, (data) => {
            console.log("SIGNALR_RECIVEONINVITEGURSTFROMVK")
            store.dispatch(update_InviteGuestforVK(data))
          });
        }

       
      break;

      case 'SIGNALR_ONBLOCKGUESTFROMVK':
        if (connection) {
          connection.on(action.eventName, (data) => {
            console.log("SIGNALR_ONBLOCKGUESTFROMVK")
            //console.log(data)
            store.dispatch(remove_InviteGuestforVK(data))
          });
        }
      break;

      case 'SIGNALR_ONREINVITEGUESTFROMVK':
        if (connection) {
         //   console.log("Listening to SIGNALR_ONREINVITEGUESTFROMVK")
            connection.on(action.eventName, (data) => {
              store.dispatch(guest_display_reinvite(data));
            });
          }
      break;

      case 'SIGNALR_RECIVE_ONDELETELOGGEDINPARTICIPANT':
        if (connection) {
          //  console.log("Listening to SIGNALR_RECIVE_ONDELETELOGGEDINPARTICIPANT")
            connection.on(action.eventName, (data) => {
              //console.log(data)
              store.dispatch(kickuser(data));
            });
          }
      break;


      case 'SIGNALR_RECIVE_STAPEL_SIG_PREPARED':
        if (connection) {
          //  console.log("Listening to SIGNALR_RECIVE_ONDELETELOGGEDINPARTICIPANT")
            connection.on(action.eventName, (data) => {
              //console.log(data) 
              store.dispatch(update_set_sigpreparestatus(data));
              
            });
          }
      break;


      case 'SIGNALR_RECIVE_STAPEL_SETUPCLOSE':
        if (connection) {
          //  console.log("Listening to SIGNALR_RECIVE_ONDELETELOGGEDINPARTICIPANT")
            connection.on(action.eventName, (data) => {
              //console.log(data) 
              if(data){
              store.dispatch(set_modal_stapel_setup_open(false));
              }
              
            });
          }
      break;

      case 'SIGNALR_RECIVE_GETADDUSER_FROMDRN':
              if (connection) {
                  // console.log("Listening to GUEST_SIGNALR_CHANGEMEETING_STATUSUSER")
                  connection.on(action.eventName, (data) => {
                    //console.log("Tab nicht aktiv")
                    store.dispatch(getadduseriframelink (data));
                  });
                }
       break;


      


      




      
      
      






      // Messages for GuestUsers
      // Send Messagges
            /**
       * Sends a request via SignalR to identify Guest User as can join. 
       * 
       * This sends a payload with the hash out of the mail to the SignalR hub.
       * The hub then requests a meeting link from the server.
       * If successful, the server will return the meeting link 
       * to the client via the SignalR connection.
       */
            case 'GUEST_SIGNALR_CHECKHASH':
              if (connectionextern) {
                //console.log("GUEST_SIGNALR_CHECKHASH")
                try {
                  // console.log("Sending Data GUEST_SIGNALR_CHECKHASH")
                await connectionextern.invoke('ValidateHash', action.payload);
                processedActions.add(action.type);
                } catch (error) {
                   console.error('Error sending message:', error);
                }
              }
            break;

            /*
            * Sends a request via SignalR to get initial meeting Data. 
            * 
            * This sends a payload of participantsid to the SignalR hub.
            * The hub then requests a meeting Data from the server.
            * If successful, the server will return meeting Data 
            * to the client via the SignalR connection.
            */
             case 'GUEST_SIGNALR_GETMEETINGDATA':
                  if (connectionextern) {
                   //console.log("GUEST_SIGNALR_GETMEETINGDATA")
                   
                   try {
                  //    console.log("Sending Data GUEST_SIGNALR_GETMEETINGDATA")
                     await connectionextern.invoke('GetGastMeetingInitData', action.payload);
                     processedActions.add(action.type);
                     } catch (error) {
                        console.error('Error sending message:', error);
                     }
                   }
              break;


            /**
            * Sends a request via SignalR to request join Link for meeting. 
            * 
            * This sends a payload with the hash out of the mail to the SignalR hub.
            * The hub then requests a meeting link from the server.
            * If successful, the server will return the meeting link 
            * to the client via the SignalR connection.
            */
                 case 'GUEST_SIGNALR_REQUEST_JOINLINK':
                   if (connectionextern) {
                   //  console.log("GUEST_SIGNALR_REQUEST_JOINLINK")
                     try {
                       // console.log("Sending Data GUEST_SIGNALR_REQUEST_JOINLINK")
                     await connectionextern.invoke('RequestGastJoinLink', action.payload);
                     //processedActions.add(action.type);
                     } catch (error) {
                        console.error('Error sending message:', error);
                     }
                   }
                 break;




                 case 'SIGNALR_REMOVEPATRICIPANTGUESTFROMCMS':
                  if (connectionextern) {
                      //console.log("SIGNALR_REMOVEPATRICIPANTFROMCMS")
                    try {
                     // console.log("Sending Data SIGNALR_REMOVEPATRICIPANTGUESTFROMCMS")
                    await connectionextern.invoke('DisconnectGuestByChangeLanguage', action.payload);
                    } catch (error) {
                      console.error('Error sending message:', error);
                    }
                  }
                break;


                case 'GUEST_SIGNALR_ON_UPDATEMEETINGPARTICIPANTS':
                  if (connectionextern) {
                      // console.log("Listening to GUEST_SIGNALR_CHANGEMEETING_STATUSUSER")
                      connectionextern.on(action.eventName, (data) => {
                        //console.log("Tab nicht aktiv")
                        store.dispatch(guest_updateparticipantsData (data));
                      });
                    }
                break;


      // Lsiten to SignalR Messages Guest
      case 'GUEST_SIGNALR_RECIVE_HASHCONFIRM':
        if (connectionextern) {
          //console.log("GUEST_SIGNALR_RECIVE_HASHCONFIRM")
          connectionextern.on(action.eventName, (data) => {
            console.log("Get Data GUEST_SIGNALR_RECIVE_HASHCONFIRM")
           // console.log(data)
            store.dispatch(guest_recive_hashconfirmdata(data))
          });
        }
      break;

      case 'GUEST_SIGNALR_RECIVEMEETINGDATA':
        if (connectionextern) {
         // console.log("Listening to GUEST_SIGNALR_RECIVEMEETINGDATA" )
          connectionextern.on(action.eventName, (data) => {
            console.log("Get Data GUEST_SIGNALR_RECIVEMEETINGDATA")
            store.dispatch(guest_recive_meetingdata(data))
          });
        }
      break;

      case 'GUEST_SIGNALR_ON_NOTIFICATIONNOTARINMEETING':
        if (connectionextern) {
        //  console.log("Listening to GUEST_SIGNALR_ON_NOTIFICATIONNOTARINMEETING" )
          connectionextern.on(action.eventName, (data) => {
            console.log("Get Data GUEST_SIGNALR_ON_NOTIFICATIONNOTARINMEETING")
            store.dispatch(guest_recive_notarnotification(data))
          });
        }
      break;

      

      case 'GUEST_SIGNALR_RECIVEJOINLINK':
        if (connectionextern) {
        //  console.log("GUEST_SIGNALR_RECIVEJOINLINK")
          connectionextern.on(action.eventName, (data) => {
            console.log("Get Data GUEST_SIGNALR_RECIVEJOINLINK")
            store.dispatch(guest_recive_joinlinkdata(data))
          });
        }
      break;

      case 'GUEST_SIGNALR_UPDATE_USERDATA':
        if (connectionextern) {
            // console.log("Listening to GUEST_SIGNALR_UPDATE_USERDATA for " + action.eventName)
            connectionextern.on(action.eventName, (data) => {
            //console.log("GET Data  GUEST_SIGNALR_UPDATE_USERDATA for " + action.eventName)
            //console.log(data)
            store.dispatch(guest_update_UserData(data));
          });
        }
      break;


    case 'GUEST_SIGNALR_CHANGEMEETING_STATUSUSER':
        if (connectionextern) {
            // console.log("Listening to GUEST_SIGNALR_CHANGEMEETING_STATUSUSER")
            connectionextern.on(action.eventName, (data) => {
             // console.log("GET Data to GUEST_SIGNALR_CHANGEMEETING_STATUSUSER")
            //  console.log(data)
            store.dispatch(guest_update_Meeting_UserStatus(data));
            });
          }
      break; 

      case 'GUEST_SIGNALR_ON_INVITEGUESTFROMVK':
        if (connectionextern) {
            // console.log("Listening to GUEST_SIGNALR_CHANGEMEETING_STATUSUSER")
            connectionextern.on(action.eventName, (data) => {
             // console.log("GET Data to GUEST_SIGNALR_CHANGEMEETING_STATUSUSER")
             // console.log(data)
              store.dispatch(guest_update_InviteGuestforVK(data))
            });
          }
      break; 

      case 'GUEST_SIGNALR_ONBLOCKGUESTFROMVK':
        if (connectionextern) {
            // console.log("Listening to GUEST_SIGNALR_CHANGEMEETING_STATUSUSER")
            connectionextern.on(action.eventName, (data) => {
             // console.log("GET Data to GUEST_SIGNALR_CHANGEMEETING_STATUSUSER")
              //console.log(data)
              store.dispatch(guest_remove_InviteGuestforVK(data))
            });
          }
      break; 

      
      // Message Handles die Anzeige das vorzulesenden Dokument
      case 'GUEST_SIGNALR_RECIVEONHANDLEDOCUMENT':
        if (connectionextern) {
         //  console.log("Listening to SIGNALR_RECIVEONHANDLEDOCUMENT")
              connectionextern.on(action.eventName, (data) => {
               store.dispatch(setshowsplitdoc(data));
            });
          }
      break;
      


      // Message das dies der aktive Tab oder das aktive Fenster ist
      case 'GUEST_SIGNALR_ON_OPENLASTACTIVELINK':
        if (connectionextern) {
            // console.log("Listening to GUEST_SIGNALR_CHANGEMEETING_STATUSUSER")
            connectionextern.on(action.eventName, (data) => {
             // console.log("GET Data to GUEST_SIGNALR_CHANGEMEETING_STATUSUSER")
             store.dispatch(display_active_tab_message(data));
            });
          }
      break;

      // Message an die nicht aktive Fenster 
      case 'GUEST_SIGNALR_ON_LINKNOTACTIVE':
        if (connectionextern) {
            // console.log("Listening to GUEST_SIGNALR_CHANGEMEETING_STATUSUSER")
            connectionextern.on(action.eventName, (data) => {
              //console.log("Tab nicht aktiv")
              store.dispatch(guest_set_notactivetab(data));
            });
          }
      break;

            // Message an die nicht aktive Fenster 
       // eslint-disable-next-line no-duplicate-case
       case 'GUEST_SIGNALR_ON_UPDATEMEETINGPARTICIPANTS':
              if (connectionextern) {
                  // console.log("Listening to GUEST_SIGNALR_CHANGEMEETING_STATUSUSER")
                  connectionextern.on(action.eventName, (data) => {
                    //console.log("Tab nicht aktiv")
                    store.dispatch(guest_updateparticipantsData (data));
                  });
                }
       break;







      

      

      
      





      


      


      





      
// Globale SignalR Listeners
      case 'SIGNALR_ON ARCHIVEDMEETING':
        if (connectionextern) {
          console.log("SIGNALR_ON ARCHIVEDMEETING")
          connectionextern.on(action.eventName, (data) => {
            console.log("Get Data GUEST_SIGNALR_RECIVEJOINLINK")
            store.dispatch(meeting_closed_error(data))
          });
        }

        if (connection) {
          connection.on(action.eventName, (data) => {
            console.log("SIGNALR_ON ARCHIVEDMEETING")
            store.dispatch(meeting_closed_error(data))
          });
        }

      break;







      /** TestSystem WS */

 // Send Messagges
            /**
       * Sends a request via SignalR to request joinlink for CMS Test. 
       * 
       * If successful, the server will return the meeting link 
       * to the client via the SignalR connection.
       */
            case 'TEST_SIGNALR_VIDEOSTART':
              if (connectionextern) {
                console.log("TEST_SIGNALR_VIDEOSTART")
                try {
                  // console.log("Sending Data GUEST_SIGNALR_CHECKHASH")
                await connectionextern.invoke('StartTestVideo');
                processedActions.add(action.type);
                } catch (error) {
                   console.error('Error sending message:', error);
                }
              }
            break;

       /**
       * Sends a request via SignalR to request joinlink for CMS Test. 
       * 
       * If successful, the server will return the meeting link 
       * to the client via the SignalR connection.
       */
      case 'TEST_SIGNALR_KICKUSER':
        if (connectionextern) {
          console.log("SIGNALRTEST_KICKUSER")
          try {
            // console.log("Sending Data GUEST_SIGNALR_CHECKHASH")
          await connectionextern.invoke('KickCurrentUserFromQueue');
          } catch (error) {
             console.error('Error sending message:', error);
          }
        }
      break;


  // Listen to Messages of Test
       case 'TEST_SIGNALR_RECIVE_STARTTESTVIDEO':
        if (connectionextern) {
          console.log("TEST_SIGNALR_RECIVE_STARTTESTVIDEO")
          connectionextern.on(action.eventName, (data) => {
            console.log("Get Data TEST_SIGNALR_RECIVE_STARTTESTVIDEO")
            console.log(data)
            store.dispatch(set_testdata(data))
          });
        }
        break;


      case 'TEST_SIGNALR_QUEUSTUPDATE':
          if (connectionextern) {
            console.log("TEST_SIGNALR_RECIVE_ONQUEUESTATUSUPDATE")
            connectionextern.on(action.eventName, (data) => {
              console.log("Get Data TEST_SIGNALR_RECIVE_ONQUEUESTATUSUPDATE")
              console.log(data)
              store.dispatch(set_testdata(data))
            });
          }
       break;


       case 'TEST_SIGNALR_LEAVEEVENT':
        if (connectionextern) {
          console.log("TEST_SIGNALR_LEAVEEVENT")
          connectionextern.on(action.eventName, (data) => {
            console.log("Get Data TEST_SIGNALR_LEAVEEVENT")
            console.log(data)
            store.dispatch(set_userleave_cms(data))
          });
        }
     break;


    

      
        

          

        


      // Close Connection
      case 'SIGNALR_DISCONNECT':
        if (connection) {
          connection.stop()
            .then(() => {
              store.dispatch(disconnect());
              console.log('SignalR connection closed.');
            })
            .catch((error) => {
              console.error('Error disconnecting from SignalR:', error);
            });
        }
        break;

      default:
        return next(action);
    }
  };
};

export default signalRMiddleware;